import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../../../core/services/api/api.service';
import { UmParticipantResponse } from '../../../models/um-participant-response';
import { UM_PARTICIPANTS_PAGE_SIZE } from '../../../core/dashboard-constants';
import { UmParticipant } from '../../../models/um-participant';

@Injectable({
  providedIn: 'root',
})
export class UmParticipantService {
  constructor(private apiService: ApiService) {}

  getUmParticipants(
    pageNumber: number,
    pageSize = UM_PARTICIPANTS_PAGE_SIZE,
    filterValue?: string
  ): Observable<UmParticipantResponse> {
    let endPoint = `/dashboard/participants/all/${pageSize}`;

    if (filterValue) {
      endPoint += `/${filterValue}`;
    }
    if (pageNumber) {
      endPoint += `?page=${pageNumber}`;
    }

    return this.apiService.get<UmParticipantResponse>(endPoint);
  }

  getUmParticipantById(participantId: number): Observable<UmParticipant> {
    return this.apiService.get<UmParticipant>(`/dashboard/participants/${participantId}`);
  }

  withdrawParticipantFromStudyAndKeepData(studyId: number, participantId: number): Observable<any> {
    return this.apiService.patch(`/dashboard/participants/${participantId}/study/${studyId}`, {});
  }

  withdrawParticipantFromStudyAndRemoveData(studyId: number, participantId: number): Observable<any> {
    return this.apiService.delete(`/dashboard/participants/${participantId}/study/${studyId}`);
  }

  withdrawParticipantFromStudyAndUnlinkData(studyId: number, participantId: number): Observable<any> {
    return this.apiService.put(`/dashboard/participants/${participantId}/study/${studyId}`, {});
  }

  deleteParticipantFromSystemAndKeepData(participantId: number): Observable<any> {
    return this.apiService.put(`/dashboard/participants/${participantId}/delete`, {});
  }

  deleteParticipantFromSystemAndRemoveData(participantId: number): Observable<any> {
    return this.apiService.delete(`/dashboard/participants/${participantId}/delete/all`);
  }

  downloadParticipantHistory(participantId: number): Observable<any> {
    return this.apiService.get(`/dashboard/participants/${participantId}/export/logins`, { responseType: 'text/csv' });
  }

  downloadParticipantStudyAnswers(participantId: number, studyId: number): Observable<any> {
      return this.apiService.get(`/dashboard/export/metrics/studies/${studyId}/participants/${participantId}`, {
        responseType: 'text/csv',
      });
  }

  downloadAllParticipantData(participantId: number): Observable<any> {
    return this.apiService.get(`/dashboard/participants/${participantId}/export/all`, { responseType: 'text/csv' });
  }
}
